import React from 'react';
import { Calendar, Clock, Video, FileText, ChevronRight, Star } from 'lucide-react';
export function AdvisoryPage() {
  const pastSessions = [{
    id: 1,
    date: 'March 10, 2026',
    topic: 'Financial Projections Review',
    duration: '45 min',
    notes: 'Reviewed Q1-Q4 projections. Need to adjust CAC assumptions based on new marketing channels.'
  }, {
    id: 2,
    date: 'February 24, 2026',
    topic: 'Go-to-Market Strategy',
    duration: '60 min',
    notes: 'Finalized target customer personas. Action item: draft initial outreach messaging for enterprise segment.'
  }, {
    id: 3,
    date: 'February 10, 2026',
    topic: 'Initial Diagnostics & Goal Setting',
    duration: '60 min',
    notes: 'Established top 3 priorities for the accelerator: 1) Refine pitch deck, 2) Solidify financial model, 3) Secure 2 pilot customers.'
  }];
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-109">
      <div className="border-b border-gray-200 pb-6" data-id="element-110">
        <h1 className="text-3xl font-heading font-bold text-catalyst-black tracking-tight" data-id="element-111">
          Strategic Advisory
        </h1>
        <p className="text-gray-500 mt-1" data-id="element-112">
          1-on-1 guidance from your dedicated industry expert
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-113">
        {/* Left Column: Advisor Profile */}
        <div className="lg:col-span-1 space-y-6" data-id="element-114">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-115">
            <div className="h-32 bg-catalyst-black relative overflow-hidden" data-id="element-116">
              <div className="absolute top-0 right-0 w-64 h-64 bg-catalyst-mustard/20 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-117"></div>
            </div>
            <div className="px-6 pb-6 relative" data-id="element-118">
              <div className="w-24 h-24 rounded-full bg-catalyst-brown-light border-4 border-white absolute -top-12 flex items-center justify-center text-white font-bold text-3xl shadow-md" data-id="element-119">
                MC
              </div>
              <div className="pt-16" data-id="element-120">
                <div className="flex justify-between items-start mb-2" data-id="element-121">
                  <div data-id="element-122">
                    <h2 className="text-xl font-bold text-catalyst-black" data-id="element-123">
                      Dr. Marcus Chen
                    </h2>
                    <p className="text-sm font-medium text-catalyst-mustard-dark" data-id="element-124">
                      Senior Growth Advisor
                    </p>
                  </div>
                  <div className="flex gap-1 text-catalyst-mustard" data-id="element-125">
                    <Star size={16} fill="currentColor" data-id="element-126" />
                    <Star size={16} fill="currentColor" data-id="element-127" />
                    <Star size={16} fill="currentColor" data-id="element-128" />
                    <Star size={16} fill="currentColor" data-id="element-129" />
                    <Star size={16} fill="currentColor" data-id="element-130" />
                  </div>
                </div>

                <p className="text-sm text-gray-600 mt-4 leading-relaxed" data-id="element-131">
                  Former VP of Growth at Stripe and 3x founder with 15+ years of
                  experience scaling B2B SaaS companies from Seed to Series C.
                  Specializes in go-to-market strategy, financial modeling, and
                  fundraising readiness.
                </p>

                <div className="mt-6 space-y-3" data-id="element-132">
                  <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-133">
                    Areas of Expertise
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-134">
                    <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-md border border-gray-200" data-id="element-135">
                      B2B SaaS
                    </span>
                    <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-md border border-gray-200" data-id="element-136">
                      Go-to-Market
                    </span>
                    <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-md border border-gray-200" data-id="element-137">
                      Fundraising
                    </span>
                    <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-md border border-gray-200" data-id="element-138">
                      Financial Modeling
                    </span>
                  </div>
                </div>

                <button className="w-full mt-8 bg-catalyst-mustard text-catalyst-black py-3 rounded-xl text-sm font-semibold hover:bg-catalyst-mustard-light transition-all shadow-sm flex items-center justify-center gap-2" data-id="element-139">
                  <Calendar size={18} data-id="element-140" />
                  Book a Session
                </button>
              </div>
            </div>
          </div>

          <div className="bg-catalyst-cream rounded-xl p-6 border border-catalyst-brown-light/20" data-id="element-141">
            <h3 className="text-sm font-bold text-catalyst-black mb-2" data-id="element-142">
              Advisory Guidelines
            </h3>
            <ul className="text-sm text-gray-600 space-y-2 list-disc pl-4" data-id="element-143">
              <li data-id="element-144">Sessions are 45-60 minutes</li>
              <li data-id="element-145">Come prepared with specific questions</li>
              <li data-id="element-146">Upload materials 24h before meeting</li>
              <li data-id="element-147">Cancel at least 24h in advance</li>
            </ul>
          </div>
        </div>

        {/* Right Column: Sessions */}
        <div className="lg:col-span-2 space-y-8" data-id="element-148">
          {/* Upcoming Session */}
          <section data-id="element-149">
            <h2 className="text-xl font-semibold text-catalyst-black mb-4" data-id="element-150">
              Upcoming Session
            </h2>
            <div className="bg-white rounded-2xl shadow-md border border-catalyst-mustard/30 p-6 relative overflow-hidden" data-id="element-151">
              <div className="absolute top-0 left-0 w-1 h-full bg-catalyst-mustard" data-id="element-152"></div>

              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6" data-id="element-153">
                <div data-id="element-154">
                  <div className="flex items-center gap-2 text-catalyst-mustard-dark font-semibold mb-2" data-id="element-155">
                    <Calendar size={18} data-id="element-156" />
                    <span data-id="element-157">Wednesday, March 25, 2026</span>
                  </div>
                  <h3 className="text-2xl font-bold text-catalyst-black mb-2" data-id="element-158">
                    Pitch Deck Review
                  </h3>
                  <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-159">
                    <span className="flex items-center gap-1" data-id="element-160">
                      <Clock size={16} data-id="element-161" /> 2:00 PM - 3:00 PM EST
                    </span>
                    <span className="flex items-center gap-1" data-id="element-162">
                      <Video size={16} data-id="element-163" /> Zoom Link
                    </span>
                  </div>
                </div>

                <div className="flex flex-col gap-3 w-full md:w-auto" data-id="element-164">
                  <button className="bg-catalyst-black text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-catalyst-brown-dark transition-colors shadow-sm w-full text-center" data-id="element-165">
                    Join Meeting
                  </button>
                  <button className="bg-white border border-gray-300 text-gray-700 px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors shadow-sm w-full text-center flex items-center justify-center gap-2" data-id="element-166">
                    <FileText size={16} data-id="element-167" />
                    Upload Materials
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Meeting History */}
          <section data-id="element-168">
            <div className="flex items-center justify-between mb-4" data-id="element-169">
              <h2 className="text-xl font-semibold text-catalyst-black" data-id="element-170">
                Meeting History
              </h2>
              <button className="text-sm text-catalyst-mustard-dark hover:text-catalyst-mustard font-medium transition-colors" data-id="element-171">
                View All
              </button>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-172">
              <div className="divide-y divide-gray-100" data-id="element-173">
                {pastSessions.map(session => <div key={session.id} className="p-6 hover:bg-gray-50 transition-colors group" data-id="element-174">
                    <div className="flex flex-col md:flex-row justify-between items-start gap-4" data-id="element-175">
                      <div className="flex-1" data-id="element-176">
                        <div className="flex items-center gap-3 mb-1" data-id="element-177">
                          <span className="text-sm font-medium text-gray-500" data-id="element-178">
                            {session.date}
                          </span>
                          <span className="w-1 h-1 rounded-full bg-gray-300" data-id="element-179"></span>
                          <span className="text-sm text-gray-500" data-id="element-180">
                            {session.duration}
                          </span>
                        </div>
                        <h3 className="text-lg font-bold text-catalyst-black mb-2 group-hover:text-catalyst-mustard-dark transition-colors" data-id="element-181">
                          {session.topic}
                        </h3>
                        <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg border border-gray-100" data-id="element-182">
                          <span className="font-semibold text-gray-700" data-id="element-183">
                            Notes:
                          </span>{' '}
                          {session.notes}
                        </p>
                      </div>
                      <button className="text-catalyst-mustard-dark p-2 rounded-full hover:bg-catalyst-mustard/10 transition-colors shrink-0" data-id="element-184">
                        <ChevronRight size={20} data-id="element-185" />
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>;
}